import { CartTableHeader } from '../../../../Constant';
import ProductContext from '../../../../_helper/Ecommerce/Product';
import { Btn, Image } from '../../../../AbstractElements';
import EmptyCart from './EmptyCart';
import { Table, Row, Input } from 'reactstrap';
import { XCircle } from 'react-feather';
import React, { Fragment, useContext, useEffect, useState } from 'react';
import CartAction from './CartAction';
import { getClientUrlDataToken, postDataWithToken } from '../../../../Utils/restUtils';
import { getCart, removeCart } from '../../../../CommonUrl';
import { toast } from 'react-toastify';
import Transparentspinner from '../../../Common/Loader/Transparentspinner';

const CartData = () => {
    const { symbol } = useContext(ProductContext);
    const [apiResponse, setapiResponse] = useState(null);
    const [loading, setLoading] = useState(false)

    useEffect(() => {
        fetchDashboardData();
    }, []);

    const fetchDashboardData = async () => {
        setLoading(true)
        const response = await getClientUrlDataToken(getCart);
        setapiResponse(response?.data);
        setLoading(false)
    }

    const incrementQty = (itemIndex) => {
        setapiResponse(prev =>
            prev.map((item, i) =>
                i === itemIndex ? { ...item, quantity: item.quantity + 1 } : item
            )
        );
    };

    const decrementQuantity = (itemIndex) => {
        setapiResponse(prev =>
            prev.map((item, i) =>
                i === itemIndex && item.quantity > 1
                    ? { ...item, quantity: item.quantity - 1 }
                    : item
            )
        );
    
    };

    const removefromcart = async (item) => {
        setLoading(true)
        const postRequest = { cart_id: item.cart_id }
        const response = await postDataWithToken(removeCart, postRequest);
        if (response.data.status) {
            fetchDashboardData();
            toast.success(response.data.message);
            setLoading(false)
        } else {
            toast.error(response.data.message);
        }
        setLoading(false)
    };

    const totalAmount = apiResponse?.reduce((acc, item) => {
        return acc + item.item_price * item.quantity;
    }, 0);
    

    return (
        <Fragment>
            {
                loading && <Transparentspinner />
            }
            {apiResponse && apiResponse.length > 0 ? (
                <div>
                    <Row>
                        <div className="order-history table-responsive wishlist">
                            <Table className="table-bordered">
                                <thead>
                                    <tr>
                                        {CartTableHeader.map((items, i) => <th key={i}>{items}</th>)}
                                    </tr>
                                </thead>
                                <tbody style={{ borderTop: 'none' }}>
                                    {
                                        apiResponse.map((item, i) => {
                                            return (
                                                <tr key={i}>
                                                    <td>
                                                        <Image attrImage={{ className: 'img-fluid img-40', src: `${item.item_image}`, alt: '#' }} />
                                                    </td>
                                                    <td><div className="product-name">{item.item_name}</div>
                                                        {item?.attributes &&
                                                            Object.entries(item?.attributes).map(([key, attr]) => (
                                                                <div key={key} style={{ fontSize: '13px', color: '#666' }}>
                                                                    {key}: {attr?.value}
                                                                </div>
                                                            ))}
                                                    </td>
                                                    <td>{item.item_price}</td>
                                                    <td>
                                                        <fieldset className='qty-box'>
                                                            <div className="input-group bootstrap-touchspin">
                                                                <span className="input-group-prepend">
                                                                    <Btn attrBtn={{

                                                                        color: 'primary', className: 'btn btn-primary btn-square bootstrap-touchspin-down',
                                                                        onClick: () => decrementQuantity(i),
                                                                        disabled: item.quantity === item.min_order,
                                                                    }}><i className="fa fa-minus"></i></Btn>
                                                                </span>
                                                                <Input type="text" name="quantity" value={item.quantity}
                                                                    readOnly={true} style={{ textAlign: 'center' }}
                                                                    className="form-control input-number" />
                                                                <span className="input-group-append">
                                                                    <Btn attrBtn={{
                                                                        color: 'primary', className: 'btn btn-primary btn-square bootstrap-touchspin-up',
                                                                        onClick: () => incrementQty(i),
                                                                        disabled: item.quantity === item.max_order,
                                                                    }}> <i className="fa fa-plus"></i></Btn> </span>

                                                            </div>
                                                            {
                                                                item.stock < item.quantity && (
                                                                    <span className="text-danger" style={{fontSize:'12px'}}>Out Of Stock</span>
                                                                )
                                                            }
                                                        </fieldset>
                                                    </td>
                                                    <td><div style={{ cursor: 'pointer' }} onClick={() => removefromcart(item)}><XCircle /></div></td>
                                                    <td>{symbol}{item.item_price * item.quantity}</td>
                                                </tr>
                                            );
                                        })
                                    }
                                    <CartAction cart={apiResponse} total={totalAmount} />
                                </tbody>
                            </Table>
                        </div>
                    </Row>
                </div>
            ) : !loading && <EmptyCart />}
        </Fragment>
    );
};
export default CartData;